import React, { useEffect, useState } from "react";
import ".././sidebar.scss";
import NavItem from "./navItem/NavItem.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { EASEBUZZ_PS_LOGO_COLOR } from "../../../../constants";

const SecondarySidebar = (props) => {
  let mql = window.matchMedia('(max-width: 620px)');
  const sidebarCollapsed = localStorage.getItem("secondary-sidebar-collapsed");
  const [isExpanded, setIsExpanded] = useState(mql.matches ? (sidebarCollapsed ? true : false) : (sidebarCollapsed ? false : true));
  const toggleSidebar = () => {
    if (isExpanded) {
      setIsExpanded(false);
      localStorage.setItem("secondary-sidebar-collapsed", true);
      return;
    }
    setIsExpanded(true);
    localStorage.removeItem("secondary-sidebar-collapsed");
  };
  return (
    <div className="secondary_sidebar_wrapper">
      {props.is_main_merchant && (
        <button
          title="show/hide menu"
          onClick={toggleSidebar}
          className="toggle_btn"
        >
          {isExpanded ? (
            <FontAwesomeIcon icon={faChevronLeft} />
          ) : (
            <FontAwesomeIcon icon={faChevronRight} />
          )}
        </button>
      )}
      <nav
        className={`${isExpanded ? `secondary_sidebar` : `collapsed_secondary_sidebar`
          }`}
      >
        <div className="d-flex flex-column h-100">
          <div>
            <div className="sidebar_top secondary_divider_border">
              {props.is_main_merchant ? <h4 className="product_heading">Wire</h4> : <img style={{ width: "80%" }} src={EASEBUZZ_PS_LOGO_COLOR} alt="easebuzz-logo" />}
            </div>

            <div className="secondary_sidebar_nav_list">
              {props.menu
                .find((item) => item.label === "Wire")
                .secondaryMenu.map((item, index) => {
                  return (
                    <>
                      {item.show &&
                        item.groupName && <span key={`${item.groupName}-${index}`} className="group-title">{item.groupName}</span>}
                      {item.groupList.map((item) => {
                        return (
                          <NavItem key={`${item.label}-${index}`} item={item} />
                        );
                      })}
                    </>
                  );
                })}
            </div>
          </div>

          {!props.is_main_merchant && (
            <div className="sidebar_bottom secondary_divider_border">
              <h4 className="product_heading">Wire</h4>
            </div>
          )}

        </div>
      </nav>
    </div>
  );
};

export default SecondarySidebar;
